/**
 * Variant Price Labels — Ausgeknipst
 * v6 Clean rewrite. All learnings baked in.
 *
 * WHAT: Injects inline prices + savings badges into variant picker pills.
 * HOW:  Custom Liquid block provides variant JSON. This script reads it,
 *       finds un-processed labels, and rewrites their content.
 * WHY RESILIENT: MutationObserver on stable parent (product-info) +
 *       change-event listener with retry. Survives Dawn Section Rendering.
 *
 * Ausgeknipst — 2026-03-25
 */
(function () {
  'use strict';

  var INJECTED = 'data-vpl';
  var cache = null;
  var HERO_TEXT = {
    de: 'Unsere Empfehlung',
    fr: 'Notre recommandation',
    en: 'Our Pick',
    es: 'Nuestra recomendaci\u00f3n',
    it: 'Il nostro consiglio'
  };

  var SAVE_TEXT = {
    de: 'Spare',
    fr: '\u00c9conomisez',
    en: 'Save',
    es: 'Ahorra',
    it: 'Risparmia'
  };

  // -- Helpers --

  function variants() {
    if (cache) return cache;
    var el = document.getElementById('variant-price-data');
    if (!el) return null;
    try { cache = JSON.parse(el.textContent); } catch (e) { return null; }
    return cache;
  }

  function getHeroId() {
    var el = document.getElementById('variant-hero-id');
    if (!el) return null;
    try {
      var val = JSON.parse(el.textContent);
      return val ? String(val).trim() : null;
    } catch (e) { return null; }
  }

  function saveText() {
    var lang = (document.documentElement.lang || 'de').slice(0, 2).toLowerCase();
    return SAVE_TEXT[lang] || SAVE_TEXT['en'];
  }

  function heroText() {
    var lang = (document.documentElement.lang || 'de').slice(0, 2).toLowerCase();
    return HERO_TEXT[lang] || HERO_TEXT['en'];
  }

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '\u00a0\u20ac';
  }

  function match(list, val) {
    for (var i = 0; i < list.length; i++) {
      var v = list[i];
      if (v.option1 === val || v.option2 === val || v.option3 === val) return v;
    }
    return null;
  }

  // -- Core --

  function run() {
    var v = variants();
    if (!v || v.length < 2) return;

    var heroId = getHeroId();

    // Find all un-processed radio labels inside variant-selects
    var fresh = document.querySelectorAll('variant-selects label:not([' + INJECTED + '])');
    if (!fresh.length) return;

    fresh.forEach(function (label) {
      var forId = label.getAttribute('for');
      if (!forId) return;
      var radio = document.getElementById(forId);
      if (!radio || radio.type !== 'radio') return;

      var variant = match(v, radio.value);
      if (!variant) return;

      // Extract the visible text (skip .visually-hidden spans)
      var name = '';
      for (var i = 0; i < label.childNodes.length; i++) {
        var n = label.childNodes[i];
        if (n.nodeType === 3 && n.textContent.trim()) { name = n.textContent.trim(); break; }
      }
      if (!name) return;

      // Save hidden accessibility spans before clearing
      var hidden = Array.prototype.slice.call(label.querySelectorAll('.visually-hidden'));

      // Clear and rebuild
      label.textContent = '';
      label.setAttribute(INJECTED, '1');
      label.classList.add('vpl');

      // Hero badge (above line 1)
      if (heroId && String(variant.id) === heroId) {
        var hero = document.createElement('span');
        hero.className = 'vpl-hero';
        hero.textContent = heroText();
        label.appendChild(hero);
      }

      // Line 1: Name (left) + Price (right)
      var l1 = document.createElement('span');
      l1.className = 'vpl-row';
      l1.innerHTML = '<span class="vpl-n">' + name + '</span>'
        + '<span class="vpl-p">' + money(variant.price) + '</span>';
      label.appendChild(l1);

      // Line 2: Savings (only when compare_at_price > price)
      var ca = variant.compare_at_price;
      if (ca && ca > variant.price) {
        var diff = ca - variant.price;
        var pct = Math.round((diff / ca) * 100);
        var l2 = document.createElement('span');
        l2.className = 'vpl-save';
        l2.innerHTML = '<s>' + money(ca) + '</s> <span class="vpl-badge">' + saveText() + ' ' + money(diff) + ' (' + pct + '%)</span>';
        label.appendChild(l2);
      }

      // Restore accessibility spans
      hidden.forEach(function (s) { label.appendChild(s); });
    });
  }

  // -- Init --

  function init() {
    run();

    // Observer on stable parent — survives variant-selects replacement
    var anchor = document.querySelector('product-info')
      || document.querySelector('[id^="MainProduct"]')
      || document.body;

    new MutationObserver(function () {
      if (document.querySelector('variant-selects label:not([' + INJECTED + '])')) run();
    }).observe(anchor, { childList: true, subtree: true });

    // Backup: change events with staggered retries
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('variant-selects')) {
        setTimeout(run, 150);
        setTimeout(run, 600);
        setTimeout(run, 1200);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function () { cache = null; init(); });
})();
